export default __webpack_public_path__ + "static/media/bathtub.b6392d24.jpg";